import { post } from "../axios/index";
export default {
  PUSH_INCLUDE: ({ commit }, String) => {
    commit("PUSH_INCLUDE", String);
  },
  DELETE_INCLUDE: ({ commit }, String) => {
    commit("DELETE_INCLUDE", String);
  },
  PUSH_AXIOS_PING: ({ commit }, obj) => {
    commit("PUSH_AXIOS_PING", obj);
  },
  REMOVE_AXIOS_PING: ({ commit }, Index) => {
    commit("REMOVE_AXIOS_PING", Index);
  },
  LOADING_SHOW: ({ commit }, Boolean) => {
    commit("LOADING_SHOW", Boolean);
  },
  SET_BACK_FLAG: ({ commit }, Boolean) => {
    commit("SET_BACK_FLAG", Boolean);
  },
  SET_LANGUAGE: ({ commit }, String = "") => {
    commit("SET_LANGUAGE", String);
  },
  SET_TOKEN: ({ commit }, String = "") => {
    commit("SET_TOKEN", String);
  },
  GET_USER_INFO: ({ commit }, { obj } = {}) => {
    // 处理异步请求的，处理用户信息
    if (obj) {
      commit("GET_USER_INFO", obj);
    } else {
      return new Promise(() => {
        post("/app/user/userInfo", {}, { loading: true }).then(res => {
          commit("GET_USER_INFO", res);
        });
      });
    }
  },
  // GET_PLATFORM_INFO: ({ commit }, { obj } = {}) => {
  //   commit("GET_PLATFORM_INFO", obj)
  // },
  GET_PLATFORM_INFO: ({ commit }) => {
    // 处理异步请求的, 处理平台信息
    return new Promise(() => {
      post("/api/index/webHome", {}, { loading: true }).then(res => {
        commit("GET_PLATFORM_INFO", res);
      });
    });
  },
  SET_SHOPCART_DATA: ({ commit }, object = {}) => {
    commit("SET_SHOPCART_DATA", object);
  },
  SET_AGAIN_ORDER: ({ commit }, object = {}) => {
    commit("SET_AGAIN_ORDER", object);
  },
  SET_LOCATION: ({ commit }, object) => {
    commit("SET_LOCATION", object);
  }
};
